import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import {Link, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Typography} from '@mui/material';

const abEnvironment = new AbEnvironment();
const DashboardVendorProblemsQuery = graphql`
query DashboardVendorProblemsQuery($vendorAccountId: UUID!) {
  vendorissuessearch(vendoraccountid: $vendorAccountId) {
    totalCount
    nodes {
      accountId
      accountName
      problemType
      problemCount
    }
  }
}
`;

const styleSheet = theme => ({
    paper: {
        marginTop: 32,
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        color: theme.palette.text.secondary,
    },
    rtable: {
      marginTop: 16,
    },
    custlink: {
      marginTop: 4,
      marginBottom: 4,
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 24,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    }
});
  
class DashboardVendorProblems extends Component {
    
  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
      const classes = this.props.classes;

      let accountId = abEnvironment.getUserAttribute('a_id');
      let issueCount = 0;

      return (
          <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={DashboardVendorProblemsQuery}
          variables={{vendorAccountId: accountId}}
          render={({error, props})=> {

            if (error) {

              return <div>{error.message}</div>

            } else if (props) {
              // only show if there is an issue
              if (props.vendorissuessearch.totalCount > 0) {

                let totalIssues = props.vendorissuessearch.totalCount;
                
                let issueSummary = '';
                if (totalIssues === 1) {
                  issueSummary = 'There is ' + totalIssues + ' action requiring your attention.';
                } else if (totalIssues > 1) {
                  issueSummary = 'There are ' + totalIssues + ' actions requiring your attention.'; 
                }

                return (
                  <Paper className={classes.paper} elevation={0} >
                    <Typography variant="h6">
                      Actions
                    </Typography>
                    <Typography variant="body2">
                      {issueSummary}
                    </Typography>
                    <TableContainer>
                      <Table className={classes.rtable}>
                        <TableHead className={classes.tblHead}>
                          <TableRow className={classes.tblHeadRow}>
                            <TableCell className={classes.tblHeadCell}>Account</TableCell>
                            <TableCell className={classes.tblHeadCell}>Action</TableCell>
                            <TableCell className={classes.tblHeadCell}>Description</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {props.vendorissuessearch.nodes.map(n => {
                            // Determine the issue cause
                            let issueType = "";
                            let issueDescription = "";
                            let aUrl = "";
                            if (n.problemType === 0) {
                              aUrl = "payout";

                              if (n.problemCount === 1) {
                                issueDescription = "There is 1 payout that needs to be approved.";
                                issueType = "Payout"
                              } else if (n.problemCount > 1) {
                                issueDescription = "There are payouts that need to be approved.";
                                issueType = "Payout"
                              }
                            }
                            issueCount++;
                            
                            return (
                              <TableRow key={issueCount}>
                                <TableCell>
                                  <Typography variant="body2">
                                    {/* Link to payout, add local storage temporary to show the approved partners */}
                                    <Link component="button" 
                                          align="left"
                                          variant="body2"
                                          onClick={() => {
                                            if (aUrl === 'payout') {
                                              localStorage.setItem('payoutShowApproved', 'true');
                                            }
                                            this.goTo(aUrl);
                                          }}>
                                      {n.accountName}
                                    </Link>
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">{issueType}</Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">{issueDescription}</Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                );  
              }
            }
              
            }}
          />
    );
  }
}

export default withStyles(styleSheet)(DashboardVendorProblems);